import {handleApiErrorResponse} from "../lib/helpers";

export function getCollaborators(token){
    return fetch(process.env.REACT_APP_API_END_POINT+'collaborator/get', {
        method: 'GET',
        headers:{"Content-Type":"application/json","Accept":"application/json","Authorization":"Bearer "+token}
    }).then((res)=>{

        const isJson = res.headers.get('content-type')?.includes('application/json');
        const data = isJson ? res.json() : null;

        if (!res.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || res.status;
            return Promise.reject(error);
        }

        return data;

    }).catch((res)=>{
        handleApiErrorResponse(res);
    });
}
export function addTeam(formValues, token){
    return fetch(process.env.REACT_APP_API_END_POINT+'collaborator/addteam', {
        method: 'POST',
        body:  formValues,
        headers:{"Authorization":"Bearer "+token}
    }).then((res)=>{

        const isJson = res.headers.get('content-type')?.includes('application/json');
        const data = isJson ? res.json() : null;

        if (!res.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || res.status;
            return Promise.reject(error);
        }

        return data;

    }).catch((res)=>{
        handleApiErrorResponse(res);
    });
}
export function addTeamMember(formValues, token){
    return fetch(process.env.REACT_APP_API_END_POINT+'collaborator/addteam', {
        method: 'POST',
        body:  formValues,
        headers:{"Authorization":"Bearer "+token}
    }).then((res)=>{

        const isJson = res.headers.get('content-type')?.includes('application/json');
        const data = isJson ? res.json() : null;

        if (!res.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || res.status;
            return Promise.reject(error);
        }

        return data;

    }).catch((res)=>{
        handleApiErrorResponse(res);
    });
}

export function verifyEmailExits(formValues, token){
    return fetch(process.env.REACT_APP_API_END_POINT+'collaborator/checkEmailExits', {
        method: 'POST',
        body:  formValues,
        headers:{"Authorization":"Bearer "+token}
    }).then((res)=>{

        const isJson = res.headers.get('content-type')?.includes('application/json');
        const data = isJson ? res.json() : null;

        if (!res.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || res.status;
            return Promise.reject(error);
        }

        return data;

    }).catch((res)=>{
        handleApiErrorResponse(res);
    });
}

export function deleteTeamMember(formValues, token){
    return fetch(process.env.REACT_APP_API_END_POINT+'collaborator/remove', {
        method: 'POST',
        body:  formValues,
        headers:{"Authorization":"Bearer "+token}
    }).then((res)=>{

        const isJson = res.headers.get('content-type')?.includes('application/json');
        const data = isJson ? res.json() : null;

        if (!res.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || res.status;
            return Promise.reject(error);
        }

        return data;

    }).catch((res)=>{
        handleApiErrorResponse(res);
    });
}

export function updateTeamMember(formValues, token){
    return fetch(process.env.REACT_APP_API_END_POINT+'collaborator/update', {
        method: 'POST',
        body:  formValues,
        headers:{"Authorization":"Bearer "+token}
    }).then((res)=>{

        const isJson = res.headers.get('content-type')?.includes('application/json');
        const data = isJson ? res.json() : null;

        if (!res.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || res.status;
            return Promise.reject(error);
        }

        return data;

    }).catch((res)=>{
        handleApiErrorResponse(res);
    });
}